<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('rules')"
      :columns="columns"
      :column_search="true"
      resource_url="/credit-analysis/rule/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("new rule") }}</span>
        </button>
      </template>
    </generic-table>

    <!-- Create/Edit Modal -->
    <rule-modal ref="modal" @saved="onSaved" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import RuleModal from "./rule_modal/Index.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  success_message,
  error_message,
} from "@/utils";
import moment from "moment";

export default {
  name: "CreditAnalysisRuleDatatable",
  components: {
    GenericTable,
    RuleModal,
  },
  data() {
    return {
      show_only_own: false,
      additional_params: {},
      columns: [
        {
          title: this.$t("name"),
          name: "name",
          searchable: true,
          // width: "25%",
          data: (row) => row.name || "",
        },
        {
          title: this.$t("description"),
          searchable: false,
          // width: "15%",
          data: (row) => row.description || "",
        },
        {
          title: this.$t("status"),
          name: "status",
          searchable: false,
          // width: "12%",
          data: (row) => {
            const statusClass = this.getStatusClass(row.status);
            return `<span class="tag ${statusClass}">${this.$t(
              row.status || "pending"
            )}</span>`;
          },
        },
        {
          title: this.$t("actions"),
          // width: "12%",
          data: (row) => {
            let v = this;
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small has-text-warning",
                click: (e) => {
                  v.$refs.modal.open(row.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete rule?"),
                    v,
                    () => {
                      del("/credit-analysis/rule", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ];

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      this.$refs.modal.open();
    },
    edit(row) {
      this.$refs.modal.open(row.uuid);
    },
    view(row) {
      this.$refs.detail_modal.open(row.uuid);
    },
    delete(row) {
      confirm_deletion_dialog(() => {
        del("/credit-analysis/request", { uuid: row.uuid })
          .then(() => {
            success_message(this.$t("request deleted successfully"));
            this.refresh();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },
    createEvaluation(row) {
      // Redirigir a la página de evaluaciones con el UUID de la solicitud
      this.$router.push({
        path: "/credit-analysis/evaluations",
        query: { request_uuid: row.uuid },
      });
    },
    refresh() {
      this.$refs.datatable.refresh();
    },
    onSaved() {
      this.refresh();
    },
    toggleFilter() {
      //   if (this.show_only_own) {
      //     this.additional_params = { filter_own: "true" };
      //   } else {
      //     this.additional_params = {};
      //   }
      this.$nextTick(() => {
        setTimeout(() => {
          this.refresh();
        }, 500);
      });
    },
    getStatusClass(status) {
      const classes = {
        pending: "is-warning",
        in_progress: "is-info",
        completed: "is-success",
      };
      return classes[status] || "is-dark";
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style scoped>
.field.is-horizontal {
  align-items: center;
}

.checkbox {
  white-space: nowrap;
}
</style>
